export default "__VITE_ASSET__CtgMAtxb__"